import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/notice-groups/NoticeGroupsAction";
import * as uiHelpers from "../NoticeGroupsUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useNoticeGroupsUIContext } from "../NoticeGroupsUIContext";

export function NoticeGroupsTable({ 
  deleteNoticeGroups 
}) {
  // Notice Groups UI Context
  const noticeGroupsUIContext = useNoticeGroupsUIContext();
  const noticeGroupsUIProps = useMemo(() => {
    return {
      ids: noticeGroupsUIContext.ids,
      setIds: noticeGroupsUIContext.setIds,
      queryParams: noticeGroupsUIContext.queryParams,
      setQueryParams: noticeGroupsUIContext.setQueryParams,
      openEditNoticeGroupPage: noticeGroupsUIContext.openEditNoticeGroupPage
    };
  }, [noticeGroupsUIContext]);

  // Getting curret state of Notice Groups list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.noticeGroups }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isEditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);
  
  // Notice Groups Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getNoticeGroups(noticeGroupsUIProps.queryParams));
    return () => dispatch(actions.cleanNoticeGroupsState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [noticeGroupsUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Adı",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "definition",
      text: "Açıklaması",
      sort: true,
      sortCaret: sortCaret,
    }
  ];

  const actionColumn = {
    dataField: "action",
    text: "İşlemler",
    formatter: columnFormatters.ActionsColumnFormatter,
    formatExtraData: {
      isEditionAuthorized,
      isDeletionAuthorized,
      openEditNoticeGroupPage: noticeGroupsUIProps.openEditNoticeGroupPage,
      deleteNoticeGroups
    },
    classes: "text-right pr-0",
    headerClasses: "text-right pr-3",
    style: {
      minWidth: "100px",
    }
  }

  if (isEditionAuthorized || isDeletionAuthorized) columns.push(actionColumn);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: noticeGroupsUIProps.queryParams.pageSize,
    page: noticeGroupsUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                noticeGroupsUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: noticeGroupsUIProps.ids,
                setIds: noticeGroupsUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}